var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import pino from 'pino';
import { generateDefaultOptions } from './options';
/**
 * A thin wrapper around pino for logging in NextJS
 *
 * See the API for pino at https://getpino.io/#/docs/api.
 *
 * Note that this logger is not intended for logging from NextJS
 * middlewares.
 *
 * @param  {...any} args
 * @returns
 */
export var generateLogger = function (name, _a) {
    var appVersion = _a.appVersion, level = _a.level, datadog = _a.datadog, options = __rest(_a, ["appVersion", "level", "datadog"]);
    // biome-ignore lint/suspicious/noConsole: Logging directly to console for the purpose of debugging the logger instance
    console.debug("Using logger \"".concat(name, "\" with level \"").concat(level, "\" on app with version \"").concat(appVersion, "\""));
    var destination;
    if (typeof window === 'undefined') {
        var streams = [
            { stream: process.stdout },
        ];
        if (datadog === null || datadog === void 0 ? void 0 : datadog.clientToken) {
            streams.push({
                stream: pino.transport({
                    caller: __filename,
                    target: 'pino-datadog-transport',
                    options: {
                        ddClientConf: {
                            authMethods: {
                                apiKeyAuth: datadog.clientToken,
                            },
                            sendImmediate: true,
                        },
                        service: datadog.service,
                        ddsource: 'nextjs',
                        ddtags: "env:".concat(datadog.env, ",owner:").concat(datadog.owner),
                    },
                }),
            });
        }
        destination = pino.multistream(streams);
    }
    return pino(__assign(__assign({ name: name }, generateDefaultOptions(level, datadog)), options), destination);
};
